import { Navigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import SeoHead from "@/components/SeoHead";

const NotFound = () => {
  const location = useLocation();
  const normalizedPath = location.pathname.replace(/\/{2,}/g, "/");

  useEffect(() => {
    if (normalizedPath === location.pathname) {
      console.error("404 Error: User attempted to access non-existent route:", location.pathname);
    }
  }, [location.pathname, normalizedPath]);

  if (normalizedPath !== location.pathname) {
    return <Navigate to={`${normalizedPath}${location.search}${location.hash}`} replace />;
  }

  return (
    <>
      <SeoHead
        title="Page Not Found — San Diego Coastal Guide"
        description="The page you're looking for doesn't exist. Head back to explore San Diego beaches, surf, tides, dining, trails, and coastal happenings."
        path={location.pathname}
      />
      <Helmet>
        <meta name="robots" content="noindex, follow" />
      </Helmet>
      <div className="flex min-h-screen items-center justify-center bg-muted">
        <div className="text-center">
          <h1 className="mb-4 text-4xl font-bold">404</h1>
          <p className="mb-4 text-xl text-muted-foreground">Oops! Page not found</p>
          <a href="/" className="text-primary underline hover:text-primary/90">
            Return to Home
          </a>
        </div>
      </div>
    </>
  );
};

export default NotFound;
